import React, { useEffect, useRef } from 'react';
import { Modal, ModalContent, ModalTypes } from '@fiverr-private/overlay';

type ModalProps = ModalTypes.ModalProps;
interface ModalAdapterProps extends ModalProps {
    className: string;
}

const ModalAdapter = ({ children, className, ...props }: ModalAdapterProps) => {
    const componentRef = useRef<HTMLDivElement>(null);
    const { isOpen } = props;

    useEffect(() => {
        const componentDOM = componentRef.current?.getElementsByTagName('article')[0];

        if (componentDOM) {
            const individualClasses = className.split(' ');
            individualClasses.forEach((className) => {
                componentDOM.classList.add(className);
            });
        }
    }, [className, isOpen]);

    return (
        <Modal {...props}>
            <ModalContent ref={componentRef}>{children}</ModalContent>
        </Modal>
    );
};

ModalAdapter.displayName = 'ModalAdapter';
export default ModalAdapter;
